import { FormControlLabel, Link, Radio, Text } from '@/theme/components';

const timeframeOptions = [
  { text: 'ASAP', value: 'ASAP' },
  { text: '1 - 3 months', value: '1 - 3 months' },
  { text: '3 - 6 months', value: '3 - 6 months' },
  { text: '6 - 12 months', value: '6 - 12 months' },
  { text: '12+ months', value: '12+ months' },
];

export const timeframeFormControlOptions = () => {
  return timeframeOptions.map((option, index) => (
    <FormControlLabel
      key={`timeline-${index}`}
      value={option.value}
      control={<Radio />}
      label={option.text}
    />
  ));
};

export const buyFormControlOptions = () => {
  return [
    <FormControlLabel key="buy-yes" value control={<Radio />} label="Yes" />,
    <FormControlLabel
      key="buy-no"
      value={false}
      control={<Radio />}
      label="No"
    />,
  ];
};

export const disclaimers = (
  <Text variant="body1" mb={2.5}>
    By clicking “Submit” I opt-in to receive calls, email, and SMS from Clever
    and agree to Clever's{' '}
    <Link target="_blank" href="https://listwithclever.com/terms-conditions/">
      Terms of Use
    </Link>
    ,{' '}
    <Link target="_blank" href="https://listwithclever.com/privacy-policy/">
      Privacy Policy
    </Link>
    , and{' '}
    <Link
      target="_blank"
      href="https://listwithclever.com/consent-to-contact-consumer/"
    >
      Consent to Contact Customer
    </Link>
    . Message and data rates apply. Message frequency varies. Text STOP to
    cancel. Text or call 1-833-225-3837 for help.
  </Text>
);
